import AppColors from 'config/AppColors';
import { Scatter, ScatterChart } from 'recharts';
import useCalendarChart, { CalendarChartProps } from './CalendarChart';

export type PeriodChartProps = CalendarChartProps & {
  dayValues: number[];
};

interface ScatterPoint {
  dayIndex: number;
  dayValue: number;
}

const PeriodChart: React.FC<PeriodChartProps> = ({
  dayLabels,
  dayValues,
  dayRange,
  periodDots,
  drawHollowPeriodDots,
  topLabels,
  showMonthLabels,
}) => {
  const { graphHeight, domainMaxDay, domainMinDay, chartBuildingBlocks } = useCalendarChart({
    dayLabels,
    dayRange,
    periodDots,
    drawHollowPeriodDots,
    topLabels,
    showMonthLabels,
  });

  const offset = dayLabels[0].diff(domainMinDay, 'days');

  const scatterPoints: ScatterPoint[] = [];
  dayValues.forEach((value, dayIndex) => {
    Array.from({ length: value || 0 }).forEach((_, index) => {
      scatterPoints.push({
        dayIndex: dayIndex + 0.5 + offset,
        dayValue: index + 1.5,
      });
    });
  });

  const customShape = (props: any) => {
    const { cx, cy } = props;
    return (
      // using a raw svg to avoid react warnings as recharts adds a lot of props to the <Drop /> component if we use it
      <svg x={cx - 4} y={cy - 6} width={8} height={12} viewBox="0 0 14 21" fill={AppColors.colorMap.veryBad}>
        <path d="M14 14C14 17.866 10.866 21 7 21C3.13401 21 0 17.866 0 14C0 10.134 3.13401 0 7 0C10.866 0 14 10.134 14 14Z" />
      </svg>
    );
  };

  return (
    <ScatterChart
      width={(domainMaxDay.diff(domainMinDay, 'days') + 1) * 14}
      height={graphHeight}
      data={dayValues}
      margin={{ top: 0, right: 0, bottom: 0, left: 0 }}
    >
      {chartBuildingBlocks}
      <Scatter animationDuration={100} data={scatterPoints} fill={AppColors.colorMap.veryBad} shape={customShape} />
    </ScatterChart>
  );
};
export default PeriodChart;
